/*
 * The side bar components & submenuSidebar components english translation
 */
export const SIDEBAR_COMPONENT_EN = {
  navigation: 'Navigation',
  home: 'Home',
  editor: 'Editor',
  cookingpot: 'Cooking Pot',
  library: 'Archive',
  prompts: 'Prompts',
  liveContent: 'Content Database',
  filerooms: 'Filerooms',
  audioBatch: 'Audio Batch',
  adminScopes: 'Admin Scopes',
  startTheTour: 'Start the Tour!',
  startVideo: 'Watch Tutorial',
  settings: 'Settings',
  accountSettings: 'User Settings',
  organisation: 'Organisation',
  billingOverview: 'Billing Overview',
  logOut: 'Log out',
  chiefEditor: 'Chief Editor',
  organisations: 'Organisations',
  users: 'Users',
  adminDashboard: 'Admin Dashboard',
  searchLibrary: 'Search archive...',
  noResults: 'No results...',
  organisationDetails: 'Organisation Details',
  profile: 'Profile',
  welcomeBack: 'Welcome Back',
  quickstart: 'Quickstart',
  toAllFunctions: 'to all functions...',
  contentDashboard: 'Content Dashboard',
  organisationSettings: 'Organisation Settings',
  managedOrganisationsSettings: 'Managed Organisations',
  openEditor: 'Open Editor',
  jumpBackIn: 'Jump back in',
  goodMorning: 'Good morning',
  goodAfternoon: 'Good afternoon',
  goodEvening: 'Good evening',
  noRecentWork: 'No recent work yet',
  homeQuickToolsTab: 'Quick tools',
  homeRecentTab: 'Recent',
  homeResearchPlaceholder: 'Ask a research question — get an answer with cited sources…',
  homeComposerPhrase1: 'Research any topic, with cited sources',
  homeComposerPhrase2: 'Write in your tone',
  homeComposerPhrase3: 'Create social posts in your format',
  homeComposerPhrase4: 'Summarize documents and links',
  homeComposerPhrase5: 'Draft, edit, and repurpose your content',
  homeResearchUnavailable: 'Chat is available only for beta access accounts.',
  homeEditorCardDescription:
    'Powerful editor that combines AI features in one place to generate high-quality text.',
  homeImageStudioDescription: 'Generate images, your imagination is the limit.',
  homeHeartbeatDescription: 'Create an automated agent that handles your research.',
  homeFileroomsDescription: 'Organize and search your documents in secure file rooms.',
  homeSegAgentLabel: 'Agents',
  homeSegEditorLabel: 'Editor',
  homeSegFileroomsLabel: 'File rooms',
  homeSegAgentDesc: 'Automate your research',
  homeSegEditorDesc: 'Write & edit with AI',
  homeSegFileroomsDesc: 'Search your documents',
  // Info line below the home composer
  homeInfoIntro: 'New to Newsrooms?',
  homeInfoLearnLink: 'Learn how to use Newsrooms',
  betaFeatureTeaser: 'This feature is in beta. Contact sales to request access.',
  betaBadge: 'Beta',
  addOnBadge: 'Add-On',
  fileroomsFeatureTeaser: 'Filerooms is available as an add-on. Contact sales to get access.',
  openNavigationSearch: 'Open navigation search',
  sidebarSheetDescription: 'Sidebar navigation drawer',
  sidebarSheetTitle: 'Navigation menu',
  hoursAgo: '{count} hours ago',
  yesterday: 'Yesterday',
  daysAgo: '{count} days ago',
  customizations: 'Customizations',
  scopes: 'Scopes',
  models: 'Feature TPrompts',
  liveContentSources: 'Live Content Sources',
  onboardingFlows: 'Onboarding Flows',
  userStyles: 'Onboarding Questionnaires',
  salesDashboard: 'Sales Dashboard',
  researchChatStatistics: 'Research Chat Analytics',
  trialEndsIn: 'Your free trial ends in',
  Trialdays: 'days',
  Trialday: 'day',
  trialExpired: 'Your free trial has expired',
  trialExtend: 'Extend',
  builders: 'Builders',
  saving: 'Saving...',
  save: 'Save',
  inputName: 'Name',
  inputNamePlaceholder: 'Enter a name',
  inputNameTooLong: 'Max {count} characters',
  inputNameTaken: 'A name like this already exists',
  inputDescription: 'Description',
  inputDescriptionPlaceholder: 'Describe what you want to capture',
  inputDescriptionHint:
    'Plain prose works best — describe the result you want and we generate from there.',
  inputUploadFiles: 'Upload files',
  inputDropFiles: 'Drop files here or click to browse',
  inputAcceptedFormats: 'PDF, DOCX, DOC, TXT (max 10 files)',
  inputUploadHint: 'Upload documents and we extract content from them.',
  inputAddUrl: 'Add URL',
  inputUrlPlaceholder: 'https://example.com/article',
  inputUrlHint: 'Add website URLs and we extract content from the page.',
  inputTextExamples: 'Text examples',
  inputTextExamplesPlaceholder: 'Paste example texts directly',
  inputTextExamplesHint: 'Paste raw text and we use it as additional context.',
  inputProcessing: 'Processing…',
  inputScraping: 'Scraping…',
  inputDone: 'Done',
  inputOptional: 'optional',
  examples: 'Examples',
  updateStyle: 'Update Style',
  addStyle: 'Add Style',
  updateLanguage: 'Update Language',
  writeManually: 'Write manually',
  addUrl: 'Add URL',
  urlPlaceholder: 'https://example.com/article',
  textExamples: 'Text Examples',
  scraping: 'Scraping...',
  done: 'Done',
  back: 'Back',
  remove: 'Remove',
  assistant: 'Chat',
  assistantDescription: 'Unified research and in-app help chat',
  researchChat: 'Chat',
  researchChatDescription: 'Chat with AI to research topics',
  fileProcessing: 'File Processing',
  newChat: 'New Chat',
  sendMessage: 'Send message',
  typeMessage: 'Type your message...',
  noSessions: 'No chat sessions yet',
  startNewChat: 'Start a new chat to begin researching',
  deleteSession: 'Delete session',
  confirmDelete: 'Are you sure you want to delete this session?',
  archiveDeleteSessionConfirm: 'Remove this session from archive?',
  archiveDeleteEntryConfirm: 'Remove this entry from archive?',
  archiveSessionDeleted: 'Session removed from archive.',
  archiveEntryDeleted: 'Entry removed from archive.',
  archiveDeleteFailed: 'Failed to delete archive item. Please try again.',
  archiveRenameFailed: 'Failed to rename archive entry. Please try again.',
  delete: 'Delete',
  edit: 'Edit',
  webSearchEnabled: 'Web search enabled',
  webSearchDisabled: 'Web search disabled',
  researchChatFormatLabel: 'Output format',
  researchChatFormatNone: 'No format',
  researchChatDraftTitlePlaceholder: 'Draft title',
  researchChatDraftInputLabel: 'Prompt',
  researchChatDraftOutputLabel: 'Draft',
  researchChatDraftArtifactTitle: 'Generated draft',
  researchChatDraftArtifactOpen: 'Open in editor',
  researchChatDraftArtifactClose: 'Close editor',
  researchChatOpenFullEditor: 'Open in full editor',
  researchChatShowInput: 'Show input',
  researchChatHideInput: 'Hide input',
  researchChatAttachFiles: 'Attach from Filerooms',
  researchChatAttachError: 'Could not read one or more attached files.',
  researchChatUploadFiles: 'Upload files',
  researchChatUploadProcessing: 'Processing…',
  researchChatUploadFailed: 'Failed to process',
  researchChatMaxAttachments: 'You can attach up to {count} files.',
  researchChatUnsupportedFile: 'Unsupported file type: {name}',
  researchChatDropHere: 'Drop files to attach (up to {count})',
  fileroomAttachTitle: 'Attach from Filerooms',
  fileroomSaveTitle: 'Save to Filerooms',
  fileroomRoots: 'File rooms',
  fileroomEmpty: 'Nothing here',
  fileroomAttachSelected: 'Attach ({count})',
  fileroomSaveHere: 'Save here',
  fileroomSaveAsWord: 'Save to Fileroom (Word)',
  fileroomSavedSuccess: 'Saved to Filerooms.',
  fileroomSaveFailed: 'Failed to save to Filerooms.',
  sessions: 'Sessions',
  untitledChat: 'Untitled Chat'
}
/*
 * The side bar components & submenuSidebar components german translation
 */
export const SIDEBAR_COMPONENT_DE = {
  navigation: 'Navigation',
  home: 'Home',
  editor: 'Editor',
  cookingpot: 'Kochtopf',
  library: 'Archiv',
  prompts: 'Prompts',
  liveContent: 'Content Datenbank',
  filerooms: 'Filerooms',
  audioBatch: 'Audio-Batch',
  adminScopes: 'Admin-Panel',
  startTheTour: 'Tour starten!',
  startVideo: 'Tutorial ansehen',
  settings: 'Einstellungen',
  accountSettings: 'Nutzereinstellungen',
  organisation: 'Organisation',
  billingOverview: 'Abrechnungsübersicht',
  logOut: 'Abmelden',
  chiefEditor: 'Chefredakteur',
  organisations: 'Organisationen',
  users: 'Nutzer',
  adminDashboard: 'Admin Dashboard',
  searchLibrary: 'Archiv durchsuchen...',
  noResults: 'Keine Ergebnisse...',
  organisationDetails: 'Organisationsdetails',
  profile: 'Profil',
  welcomeBack: 'Willkommen Zurück',
  quickstart: 'Quickstart',
  toAllFunctions: 'zu allen Funktionen...',
  contentDashboard: 'Content Dashboard',
  organisationSettings: 'Organisations Einstellungen',
  managedOrganisationsSettings: 'Verwaltete Organisationen',
  openEditor: 'Editor öffnen',
  jumpBackIn: 'Zuletzt bearbeitet',
  goodMorning: 'Guten Morgen',
  goodAfternoon: 'Guten Tag',
  goodEvening: 'Guten Abend',
  noRecentWork: 'Noch keine Projekte',
  homeQuickToolsTab: 'Schnellzugriff',
  homeRecentTab: 'Zuletzt',
  homeResearchPlaceholder: 'Stellen Sie eine Recherchefrage – Antwort mit Quellenangaben …',
  homeComposerPhrase1: 'Recherchiere jedes Thema – mit Quellen',
  homeComposerPhrase2: 'Schreibe in deinem Ton',
  homeComposerPhrase3: 'Erstelle Social Posts in deinem Format',
  homeComposerPhrase4: 'Fasse Dokumente und Links zusammen',
  homeComposerPhrase5: 'Entwirf, bearbeite und verwerte deine Inhalte',
  homeResearchUnavailable: 'Der Chat ist nur für Konten mit Beta-Zugang verfügbar.',
  homeEditorCardDescription:
    'Leistungsstarker Editor, der KI-Funktionen an einem Ort bündelt, um hochwertige Texte zu erstellen.',
  homeImageStudioDescription: 'Generiere Bilder, deiner Fantasie sind keine Grenzen gesetzt.',
  homeHeartbeatDescription:
    'Erstelle einen automatisierten Agenten, der deine Recherche übernimmt.',
  homeFileroomsDescription: 'Organisiere und durchsuche deine Dokumente in sicheren Filerooms.',
  homeSegAgentLabel: 'Agenten',
  homeSegEditorLabel: 'Editor',
  homeSegFileroomsLabel: 'Filerooms',
  homeSegAgentDesc: 'Automatisiere deine Recherche',
  homeSegEditorDesc: 'Schreiben & Bearbeiten mit KI',
  homeSegFileroomsDesc: 'Durchsuche deine Dokumente',
  // Infozeile unter dem Home-Composer
  homeInfoIntro: 'Neu bei Newsrooms?',
  homeInfoLearnLink: 'Erfahre, wie du Newsrooms nutzt',
  betaFeatureTeaser:
    'Diese Funktion ist in der Beta. Kontaktieren Sie den Vertrieb, um Zugang anzufragen.',
  betaBadge: 'Beta',
  addOnBadge: 'Add-On',
  fileroomsFeatureTeaser:
    'Filerooms ist als Zusatzmodul verfügbar. Kontaktieren Sie den Vertrieb, um Zugang zu erhalten.',
  openNavigationSearch: 'Navigationssuche öffnen',
  sidebarSheetDescription: 'Seitenleisten-Navigationsbereich',
  sidebarSheetTitle: 'Navigationsmenü',
  hoursAgo: 'vor {count} Stunden',
  yesterday: 'Gestern',
  daysAgo: 'vor {count} Tagen',
  customizations: 'Customizations',
  scopes: 'Scopes',
  models: 'Feature TPrompts',
  liveContentSources: 'Live Content Sources',
  onboardingFlows: 'Onboarding Flows',
  userStyles: 'Onboarding Questionnaires',
  salesDashboard: 'Sales Dashboard',
  researchChatStatistics: 'Research-Chat-Analysen',
  trialEndsIn: 'Ihre kostenlose Testphase endet in',
  Trialdays: 'Tagen',
  Trialday: 'Tag',
  trialExpired: 'Ihre kostenlose Testphase ist abgelaufen',
  trialExtend: 'Jetzt upgraden',
  builders: 'Builder',
  saving: 'Speichern...',
  save: 'Speichern',
  inputName: 'Name',
  inputNamePlaceholder: 'Name eingeben',
  inputNameTooLong: 'Maximal {count} Zeichen',
  inputNameTaken: 'Ein Eintrag mit diesem Namen existiert bereits',
  inputDescription: 'Beschreibung',
  inputDescriptionPlaceholder: 'Beschreiben Sie, was Sie erfassen möchten',
  inputDescriptionHint:
    'Fließtext eignet sich am besten — beschreiben Sie das gewünschte Ergebnis, wir generieren daraus.',
  inputUploadFiles: 'Dateien hochladen',
  inputDropFiles: 'Dateien hier ablegen oder zum Durchsuchen klicken',
  inputAcceptedFormats: 'PDF, DOCX, DOC, TXT (max. 10 Dateien)',
  inputUploadHint: 'Dokumente hochladen, wir extrahieren Inhalt daraus.',
  inputAddUrl: 'URL hinzufügen',
  inputUrlPlaceholder: 'https://beispiel.com/artikel',
  inputUrlHint: 'Webseiten-URLs hinzufügen, wir extrahieren Inhalt von der Seite.',
  inputTextExamples: 'Textbeispiele',
  inputTextExamplesPlaceholder: 'Beispieltexte direkt einfügen',
  inputTextExamplesHint: 'Rohtext einfügen, wir nutzen ihn als zusätzlichen Kontext.',
  inputProcessing: 'Wird verarbeitet…',
  inputScraping: 'Wird gescraped…',
  inputDone: 'Fertig',
  inputOptional: 'optional',
  examples: 'Beispiele',
  updateStyle: 'Stil aktualisieren',
  addStyle: 'Stil hinzufügen',
  updateLanguage: 'Sprache aktualisieren',
  writeManually: 'Manuell schreiben',
  addUrl: 'URL hinzufügen',
  urlPlaceholder: 'https://example.com/artikel',
  textExamples: 'Textbeispiele',
  scraping: 'Wird gescraped...',
  done: 'Fertig',
  back: 'Zurück',
  remove: 'Entfernen',
  assistant: 'Chat',
  assistantDescription: 'Vereinter Recherche- und In-App-Hilfe-Chat',
  researchChat: 'Chat',
  researchChatDescription: 'Chatten Sie mit KI, um Themen zu recherchieren',
  fileProcessing: 'Dateiverarbeitung',
  newChat: 'Neuer Chat',
  sendMessage: 'Nachricht senden',
  typeMessage: 'Nachricht eingeben...',
  noSessions: 'Noch keine Chat-Sitzungen',
  startNewChat: 'Starten Sie einen neuen Chat, um mit der Recherche zu beginnen',
  deleteSession: 'Sitzung löschen',
  confirmDelete: 'Sind Sie sicher, dass Sie diese Sitzung löschen möchten?',
  archiveDeleteSessionConfirm: 'Diese Sitzung aus dem Archiv entfernen?',
  archiveDeleteEntryConfirm: 'Diesen Eintrag aus dem Archiv entfernen?',
  archiveSessionDeleted: 'Sitzung aus dem Archiv entfernt.',
  archiveEntryDeleted: 'Eintrag aus dem Archiv entfernt.',
  archiveDeleteFailed: 'Archivobjekt konnte nicht gelöscht werden. Bitte erneut versuchen.',
  archiveRenameFailed: 'Archiv-Eintrag konnte nicht umbenannt werden. Bitte erneut versuchen.',
  delete: 'Löschen',
  edit: 'Bearbeiten',
  webSearchEnabled: 'Websuche aktiviert',
  webSearchDisabled: 'Websuche deaktiviert',
  researchChatFormatLabel: 'Ausgabeformat',
  researchChatFormatNone: 'Kein Format',
  researchChatDraftTitlePlaceholder: 'Entwurfstitel',
  researchChatDraftInputLabel: 'Eingabe',
  researchChatDraftOutputLabel: 'Entwurf',
  researchChatDraftArtifactTitle: 'Generierter Entwurf',
  researchChatDraftArtifactOpen: 'Im Editor öffnen',
  researchChatDraftArtifactClose: 'Editor schließen',
  researchChatOpenFullEditor: 'Im vollen Editor öffnen',
  researchChatShowInput: 'Eingabe anzeigen',
  researchChatHideInput: 'Eingabe ausblenden',
  researchChatAttachFiles: 'Aus Filerooms anhängen',
  researchChatAttachError: 'Eine oder mehrere angehängte Dateien konnten nicht gelesen werden.',
  researchChatUploadFiles: 'Dateien hochladen',
  researchChatUploadProcessing: 'Wird verarbeitet…',
  researchChatUploadFailed: 'Verarbeitung fehlgeschlagen',
  researchChatMaxAttachments: 'Du kannst bis zu {count} Dateien anhängen.',
  researchChatUnsupportedFile: 'Nicht unterstützter Dateityp: {name}',
  researchChatDropHere: 'Dateien hier ablegen (bis zu {count})',
  fileroomAttachTitle: 'Aus Filerooms anhängen',
  fileroomSaveTitle: 'In Filerooms speichern',
  fileroomRoots: 'Filerooms',
  fileroomEmpty: 'Nichts vorhanden',
  fileroomAttachSelected: 'Anhängen ({count})',
  fileroomSaveHere: 'Hier speichern',
  fileroomSaveAsWord: 'In Fileroom speichern (Word)',
  fileroomSavedSuccess: 'In Filerooms gespeichert.',
  fileroomSaveFailed: 'Speichern in Filerooms fehlgeschlagen.',
  sessions: 'Sitzungen',
  untitledChat: 'Unbenannter Chat'
}
